import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevision: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTelevision"><Path d="M2.5 3.5H21.5V17.5H2.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M18 20.5C16.114 19.8513 14.0967 19.5 12 19.5C9.90334 19.5 7.88601 19.8513 6 20.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTelevision;
